export const faqItems = [
  {
    question: '黑料718是什么类型的网站？',
    answer: '黑料718是一个专注于娱乐圈、网红圈及社会热点事件的吃瓜内容聚合平台，为用户提供最新、最全的黑料资讯和独家爆料内容，是吃瓜群众获取一手八卦的首选入口。',
  },
  {
    question: '如何找到黑料718的最新网址？',
    answer: '黑料718官网会持续更新最新网址入口，建议您收藏本页面或关注黑料718官方社交媒体账号，我们会第一时间发布网址变更通知，确保您不会错过任何精彩吃瓜内容。',
  },
  {
    question: '黑料718的内容多久更新一次？',
    answer: '黑料718保持全天候滚动更新，重大爆料事件发生后15分钟内即可上线相关专题内容。日常热点每天更新量超过50条，确保您随时刷新都有新鲜吃瓜内容可看。',
  },
  {
    question: '访问黑料718需要注册账号吗？',
    answer: '黑料718目前采用完全开放访问模式，无需注册、无需登录即可浏览全部内容。我们坚持零门槛原则，让每一位吃瓜群众都能轻松获取最新黑料资讯。',
  },
  {
    question: '黑料718的内容来源是否可靠？',
    answer: '黑料718建立了严格的内容审核机制，所有爆料内容均经过多渠道交叉验证后发布。我们与多家行业媒体和资深爆料人保持合作关系，力求为读者提供经得起推敲的吃瓜内容。',
  },
  {
    question: '为什么黑料718有时打不开？',
    answer: '由于黑料718内容热度较高、访问量巨大，可能偶尔出现服务器波动或域名访问限制的情况。建议您使用本站提供的多个备用入口，或切换网络环境后重试，通常几分钟内即可恢复正常访问。',
  },
];

export const indexTopics = [
  { title: '明星恋情大揭秘', count: 128, tag: '热', icon: 'ri-heart-line' },
  { title: '网红塌房实录', count: 96, tag: '新', icon: 'ri-alert-line' },
  { title: '综艺内幕曝光', count: 87, tag: '爆', icon: 'ri-tv-line' },
  { title: '娱乐圈税务风波', count: 74, icon: 'ri-money-cny-circle-line' },
  { title: '选秀节目暗箱操作', count: 63, icon: 'ri-mic-line' },
  { title: '明星私生活争议', count: 59, icon: 'ri-user-smile-line' },
  { title: '品牌代言翻车合集', count: 52, icon: 'ri-shopping-bag-line' },
  { title: '直播带货内幕', count: 48, tag: '新', icon: 'ri-live-line' },
  { title: '饭圈文化深度观察', count: 41, icon: 'ri-group-line' },
];

export const updates = [
  { date: '2026-07-30', time: '14:22', title: '某顶流男星深夜私会神秘女子，酒店监控画面流出引热议', tag: '最新' },
  { date: '2026-07-30', time: '10:15', title: '知名导演被曝剧组耍大牌，多位演员实名控诉其恶劣行径', tag: '热' },
  { date: '2026-07-29', time: '22:08', title: '某选秀冠军涉嫌学历造假，母校回应称正在核实相关材料', tag: '爆' },
  { date: '2026-07-29', time: '16:45', title: '女星离婚案新进展：财产分割涉及多处豪宅和海外资产', tag: '热' },
  { date: '2026-07-28', time: '19:30', title: '品牌方集体解约风波：代言人丑闻牵连三家上市公司股价下跌', tag: '' },
  { date: '2026-07-28', time: '11:00', title: '某大胃王吃播被实锤假吃翻车，幕后团队连夜删视频遭网友截图', tag: '' },
  { date: '2026-07-27', time: '08:55', title: '娱乐圈再掀税务稽查风暴，多名艺人被约谈补缴巨额税款', tag: '爆' },
];

export const aboutContent = {
  title: '关于黑料718',
  paragraphs: [
    '黑料718品牌创立于吃瓜文化的黄金时代，致力于为广大网友打造一个专业、快捷、全面的黑料吃瓜内容聚合平台。我们深知在信息爆炸的互联网时代，真正有价值的爆料内容往往散落在各个角落，普通用户很难第一时间获取到一手资讯。黑料718的使命就是解决这一痛点——通过专业的内容采编团队和智能聚合技术，将分散在全网的黑料吃瓜内容汇聚一处，让每一位吃瓜群众都能以最快的速度了解事件全貌。',
    '目前黑料718已建立起覆盖娱乐圈、网红圈、综艺影视、品牌商业等多个领域的内容矩阵，日均更新量超过50条，累计服务超过百万吃瓜用户。我们不仅提供最新的爆料资讯，更注重内容的深度和可信度，所有重大事件均会跟进多方信源进行交叉验证，力求在第一时间呈现最接近真相的内容。',
  ],
};

export const cards = [
  {
    title: '某当红小生被曝隐婚三年',
    desc: '据知情人士透露，该男星与圈外女友早在三年前就已秘密领证，期间一直对外维持单身人设，代言合同或面临巨额违约赔偿。',
    tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20composition%20with%20warm%20crimson%20and%20dark%20tones%2C%20stylized%20silhouette%20figures%20in%20dim%20lighting%2C%20mysterious%20atmosphere%20with%20soft%20glow%20accents%2C%20editorial%20photography%20style%20with%20cinematic%20mood%2C%20subtle%20geometric%20patterns%2C%20high%20contrast%2C%20dark%20background%20with%20warm%20highlights&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '知名女星税务问题再升级',
    desc: '继去年补缴税款后，该女星近日又被查出关联公司存在虚开发票嫌疑，涉案金额或超过3000万，相关部门已正式立案调查。',
    tag: '追踪',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20with%20warm%20amber%20and%20crimson%20tones%2C%20stylized%20business%20documents%20and%20legal%20papers%20scattered%20artistically%2C%20dramatic%20lighting%20from%20side%2C%20dark%20sophisticated%20background%2C%20cinematic%20noir%20atmosphere%2C%20professional%20mood%20with%20subtle%20tension&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '选秀导师私下收取好处费',
    desc: '某热门选秀节目导师被学员家属实名举报，称其以"指导费"名义索取数十万元，承诺保送晋级但最终未兑现，聊天记录曝光。',
    tag: '重磅',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20stage%20performance%20concept%20with%20dramatic%20spotlight%20and%20shadow%20play%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20stylized%20theatrical%20curtains%20with%20mysterious%20atmosphere%2C%20dark%20background%20with%20warm%20highlights%2C%20cinematic%20composition%2C%20editorial%20photography%20aesthetic&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '直播一哥带货数据被质疑造假',
    desc: '第三方数据机构发布报告指出，某头部主播直播间实际成交额与公布数据存在数倍差距，大量订单在直播结束后被批量退款。',
    tag: '热议',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20commerce%20concept%20with%20warm%20neon-like%20glows%20on%20dark%20background%2C%20stylized%20data%20charts%20and%20numbers%20floating%20artistically%2C%20crimson%20and%20amber%20color%20scheme%2C%20modern%20digital%20art%20style%2C%20atmospheric%20with%20subtle%20light%20streaks%2C%20editorial%20mood&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '某综艺常驻嘉宾后台冲突曝光',
    desc: '据现场工作人员爆料，两位常驻嘉宾因镜头分配问题在化妆间发生激烈争执，节目组紧急介入调停，当期节目被迫重新剪辑。',
    tag: '新料',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20confrontation%20concept%20with%20split%20composition%2C%20warm%20and%20cool%20contrasting%20tones%2C%20stylized%20human%20silhouettes%20facing%20each%20other%2C%20crimson%20and%20dark%20amber%20palette%2C%20cinematic%20lighting%20with%20intense%20mood%2C%20editorial%20photography%20aesthetic%2C%20dark%20background&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    title: '女团成员被前经纪公司索赔千万',
    desc: '某当红女团成员单方面解约后被原经纪公司起诉，要求赔偿培训费、包装费及预期收益损失共计1200万元，粉丝发起众筹维权。',
    tag: '焦点',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20legal%20drama%20concept%20with%20stylized%20contract%20papers%20floating%20in%20dramatic%20lighting%2C%20warm%20crimson%20and%20dark%20gold%20tones%2C%20theatrical%20spotlight%20effect%20on%20dark%20background%2C%20cinematic%20noir%20atmosphere%2C%20editorial%20composition%2C%20professional%20mood&width=800&height=500&seq=card-06&orientation=landscape',
  },
  {
    title: '知名导演新片被指抄袭海外作品',
    desc: '影评人逐帧对比后列出多达17处相似场景和台词，导演回应称"致敬经典"但原作方表示正在评估法律维权可能性。',
    tag: '争议',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20film%20comparison%20concept%20with%20split%20screen%20composition%2C%20warm%20amber%20and%20crimson%20dual%20tone%2C%20stylized%20movie%20frames%20overlapping%20artistically%2C%20dark%20sophisticated%20background%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20style%2C%20dramatic%20lighting&width=800&height=500&seq=card-07&orientation=landscape',
  },
];

export const carouselItems = [
  {
    title: '2026娱乐圈半年大事件全回顾',
    desc: '从年初的税务风暴到年中的恋情连环爆，这半年来娱乐圈可谓风起云涌。多位顶流艺人接连陷入争议，品牌解约潮此起彼伏，选秀节目乱象被集中整治——我们为您梳理了这半年来最具话题性的30个重大事件。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20wide%20composition%20with%20dramatic%20timeline%20concept%2C%20warm%20crimson%20and%20dark%20amber%20gradient%2C%20stylized%20news%20headlines%20floating%20in%20atmospheric%20space%2C%20editorial%20photography%20style%2C%20dark%20background%20with%20warm%20glowing%20accents%2C%20professional%20mood&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '顶流明星恋情连环爆：谁在说谎？',
    desc: '短短两周内，三位一线明星相继被曝光恋情，但当事人回应却前后矛盾。有人火速官宣，有人坚决否认，还有人选择冷处理——这背后究竟藏着怎样的公关博弈和商业考量？',
    tag: '深度追踪',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20romantic%20drama%20concept%20with%20three%20stylized%20portrait%20silhouettes%20in%20warm%20lighting%2C%20crimson%20and%20rose%20gold%20tones%2C%20soft%20glow%20effects%20on%20dark%20background%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20aesthetic%2C%20mysterious%20mood&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '选秀产业链大起底：从海选到成团',
    desc: '一个选秀冠军的背后，是数十家利益相关方的精密运作。从经纪公司的"买位费"到赞助商的"保送协议"，从数据造假的灰色产业链到粉丝经济的疯狂收割——我们深入调查了选秀节目不为人知的商业真相。',
    tag: '独家调查',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20stage%20behind%20scenes%20concept%20with%20dramatic%20backstage%20lighting%2C%20warm%20amber%20and%20dark%20crimson%20tones%2C%20stylized%20industrial%20elements%20blending%20with%20theatrical%20atmosphere%2C%20cinematic%20wide%20composition%2C%20editorial%20style%2C%20dark%20sophisticated%20background&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '网红经济泡沫破裂：百万粉博主的真实收入',
    desc: '当"月入百万"的神话被戳破，当品牌方开始用ROI而非粉丝量来衡量合作价值——我们采访了十位不同量级的网红博主，还原了这个行业最真实的经济账。有人年入千万，有人入不敷出。',
    tag: '行业洞察',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20economy%20concept%20with%20floating%20numbers%20and%20social%20media%20icons%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20stylized%20data%20visualization%20in%20atmospheric%20space%2C%20dark%20background%20with%20soft%20glowing%20elements%2C%20editorial%20mood%2C%20cinematic%20wide%20shot&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '饭圈文化十年变迁：从应援棒到举报键',
    desc: '十年前，追星是举着灯牌在演唱会呐喊；十年后，追星变成了在社交媒体上的控评、反黑和举报大战。饭圈文化如何演变成今天的样子？它的未来又将走向何方？',
    tag: '文化观察',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20crowd%20culture%20concept%20with%20stylized%20glowing%20dots%20forming%20organic%20patterns%2C%20warm%20amber%20and%20deep%20crimson%20gradient%2C%20atmospheric%20concert-like%20lighting%20on%20dark%20background%2C%20cinematic%20wide%20composition%2C%20editorial%20photography%20aesthetic%2C%20emotional%20mood&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
  {
    title: '明星代言翻车启示录：品牌如何避坑？',
    desc: '2026年上半年已有超过15位艺人因负面新闻被品牌方紧急解约，累计损失超过8亿元。从背景调查到道德条款，品牌方开始建立更严格的艺人风险评估体系——但这份"避坑指南"真的有用吗？',
    tag: '商业分析',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20business%20risk%20concept%20with%20stylized%20contract%20papers%20and%20warning%20signs%2C%20warm%20crimson%20and%20dark%20gold%20tones%2C%20dramatic%20lighting%20from%20above%2C%20dark%20sophisticated%20background%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20style&width=1200&height=600&seq=carousel-06&orientation=landscape',
  },
];

export const comments = [
  {
    name: '吃瓜一线群众',
    time: '2小时前',
    content: '这个网站太牛了，每次有大瓜都能在这里第一时间看到完整的时间线梳理，比刷微博碎片信息强太多了！已经推荐给身边所有吃瓜小伙伴。',
    likes: 1286,
  },
  {
    name: '娱乐圈观察员',
    time: '5小时前',
    content: '关注黑料718快一年了，内容质量确实行业内领先。尤其是深度调查类文章，逻辑清晰证据链完整，看得出团队是认真在做内容而非简单搬运。',
    likes: 953,
  },
  {
    name: '匿名网友小A',
    time: '8小时前',
    content: '之前一直找不到稳定入口，每次都要搜半天。收藏了这个页面以后方便多了，更新也快，基本上热搜还没上去这边就已经有详细爆料了。',
    likes: 721,
  },
  {
    name: '理性吃瓜人',
    time: '1天前',
    content: '说实话现在网上假瓜太多了，好在718这边的内容都会标注信源等级，让我这种理性吃瓜的人也能分辨哪些是实锤哪些是传闻，这个功能很赞。',
    likes: 538,
  },
  {
    name: '深夜吃瓜选手',
    time: '1天前',
    content: '夜班摸鱼必刷网站！最近那个选秀内幕的系列报道追了三天了，每一篇都干货满满。希望能继续保持这个更新频率，吃瓜人永远支持你们！',
    likes: 412,
  },
];

export const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '重大爆料事件15分钟内上线专题，热点事件全天候滚动追踪，比其他平台平均快30分钟以上，让您永远快人一步吃到第一手瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '信源验证',
    desc: '所有爆料内容均标注信源等级，从"多方实锤"到"单方传闻"共分四级，帮助读者理性判断内容可信度，拒绝盲目跟风传谣。',
  },
  {
    icon: 'ri-stack-line',
    title: '内容聚合',
    desc: '覆盖娱乐圈、网红圈、综艺影视、品牌商业等八大领域，每日更新量超50条，一站在手吃遍全网瓜，再也不用在多个平台间反复横跳。',
  },
  {
    icon: 'ri-links-line',
    title: '多入口保障',
    desc: '提供多个备用访问入口和镜像站点，即使在访问高峰期或网络波动时也能确保稳定连接，真正解决"找不到入口"的核心痛点。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '隐私保护',
    desc: '无需注册登录即可浏览全部内容，不追踪用户行为数据，不强制弹窗广告，为每一位吃瓜群众提供纯净、安全的浏览体验。',
  },
];

export const appEntry = {
  title: '随时随地 吃瓜不停',
  desc: '黑料718移动端入口现已全面适配，无论您使用手机还是平板，都能获得流畅的吃瓜浏览体验。打开手机浏览器输入网址即可访问，无需下载APP，省内存、更新快、零门槛。',
  icon: 'ri-smartphone-line',
};

export const contactEntry = {
  title: '投稿爆料 / 商务合作',
  desc: '如果您掌握独家爆料线索，或希望与黑料718开展商务合作，欢迎通过以下方式联系我们。所有爆料人信息将严格保密，重大独家线索一经采用将提供丰厚稿酬回报。',
  items: [
    { label: '爆料投稿', icon: 'ri-mail-send-line', value: 'tips@heiliao718.com' },
    { label: '商务合作', icon: 'ri-briefcase-line', value: 'biz@heiliao718.com' },
    { label: '内容反馈', icon: 'ri-feedback-line', value: 'feedback@heiliao718.com' },
  ],
};

export const topics = [
  { name: '明星恋情', heat: 98, count: '12.8万' },
  { name: '税务风波', heat: 95, count: '11.2万' },
  { name: '选秀内幕', heat: 91, count: '9.6万' },
  { name: '网红塌房', heat: 88, count: '8.9万' },
  { name: '品牌解约', heat: 85, count: '7.4万' },
  { name: '饭圈文化', heat: 82, count: '6.8万' },
  { name: '综艺争议', heat: 78, count: '5.9万' },
  { name: '直播翻车', heat: 75, count: '5.2万' },
  { name: '影视抄袭', heat: 71, count: '4.6万' },
  { name: '艺人解约', heat: 68, count: '4.1万' },
];

export const mediaItems = [
  {
    title: '2026上半年娱乐圈大事件全记录',
    desc: '30分钟回顾今年最具话题性的娱乐事件，从恋情曝光到税务风暴，一网打尽所有精彩瞬间。',
    duration: '30:25',
    views: '128.6万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20video%20thumbnail%20concept%20with%20dramatic%20play%20button%20and%20timeline%20elements%2C%20warm%20crimson%20and%20dark%20amber%20gradient%2C%20cinematic%20lighting%20with%20lens%20flare%20accent%2C%20dark%20background%2C%20editorial%20style%2C%20professional%20composition&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    title: '深度揭秘：选秀节目的资本游戏',
    desc: '一位前选秀节目制作组成员的独家爆料，揭露选秀背后不为人知的资本运作和利益链条。',
    duration: '22:18',
    views: '96.3万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20investigative%20journalism%20concept%20with%20stylized%20magnifying%20glass%20and%20document%20elements%2C%20warm%20amber%20and%20crimson%20tones%2C%20dramatic%20side%20lighting%2C%20dark%20sophisticated%20background%2C%20editorial%20photography%20aesthetic%2C%20cinematic%20mood&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    title: '网红经济真相：百万粉丝≠百万收入',
    desc: '采访十位不同量级的网红博主，用真实数据告诉你这个行业的水有多深，泡沫有多大。',
    duration: '18:42',
    views: '85.7万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20influencer%20economy%20concept%20with%20stylized%20social%20media%20icons%20and%20data%20charts%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20modern%20digital%20art%20style%2C%20dark%20background%20with%20soft%20glowing%20accents%2C%20editorial%20mood%2C%20cinematic%20atmosphere&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export const rankingItems = [
  { rank: 1, title: '顶流男星深夜私会神秘女子，酒店监控流出', heat: '🔥 1280万', trend: 'up', change: '↑ 3' },
  { rank: 2, title: '知名女星税务案升级：关联公司涉嫌虚开发票', heat: '🔥 1150万', trend: 'up', change: '↑ 1' },
  { rank: 3, title: '选秀导师收取好处费被实名举报', heat: '🔥 980万', trend: 'up', change: '↑ 5' },
  { rank: 4, title: '直播一哥带货数据造假，第三方报告实锤', heat: '890万', trend: 'down', change: '↓ 2' },
  { rank: 5, title: '综艺常驻嘉宾后台冲突，节目被迫重新剪辑', heat: '760万', trend: 'up', change: '↑ 7' },
  { rank: 6, title: '女团成员被前经纪公司索赔1200万', heat: '680万', trend: 'up', change: '↑ 4' },
];